import { useEffect, useState } from "react";




export const servicesList = [
  { id: 1, name: 'فحص قلب شامل', price: 800, duration: 45 },
  { id: 2, name: 'استشارة قلبية', price: 500, duration: 30 },
  { id: 3, name: 'متابعة ما بعد العملية', price: 300, duration: 20 },
  { id: 4, name: 'استشارة جراحية', price: 1000, duration: 60 },
  { id: 5, name: 'اختبار جهد استشاري النساء والتوليد', price: 700, duration: 40 },
  { id: 6, name: 'موجات صوتية على استشاري النساء والتوليد', price: 600, duration: 30 },
];

export const initialBookings = [
  { id: 1, name: 'محمد خالد توفيق', phone: '01234567890', email: 'ahmed@email.com', service: 'فحص قلب شامل', date: '2026-06-20', time: '10:00 ص', price: 800, status: 'مؤكد', notes: '' },
  { id: 2, name: 'سارة علي', phone: '01123456789', email: 'sara@email.com', service: 'استشارة قلبية', date: '2026-06-21', time: '02:00 م', price: 500, status: 'مؤكد', notes: 'مريضة ضغط' },
  { id: 3, name: 'محمد حسن', phone: '01098765432', email: 'mohamed@email.com', service: 'اختبار جهد استشاري النساء والتوليد', date: '2026-06-22', time: '09:30 ص', price: 700, status: 'قيد الانتظار', notes: '' },
  { id: 4, name: 'فاطمة محمد خالد توفيق', phone: '01567890123', email: 'fatma@email.com', service: 'موجات صوتية على استشاري النساء والتوليد', date: '2026-06-23', time: '11:00 ص', price: 600, status: 'مؤكد', notes: 'حالة طارئة' },
  { id: 5, name: 'خالد سامي', phone: '01239876543', email: 'khaled@email.com', service: 'متابعة ما بعد العملية', date: '2026-06-24', time: '03:00 م', price: 300, status: 'ملغي', notes: 'ألغى الحجز' },
  { id: 6, name: 'نور الدين', phone: '01122334455', email: 'nour@email.com', service: 'استشارة جراحية', date: '2026-06-25', time: '10:30 ص', price: 1000, status: 'مؤكد', notes: '' },
  { id: 7, name: 'ليلى محمود', phone: '01011223344', email: 'laila@email.com', service: 'فحص قلب شامل', date: '2026-06-26', time: '12:00 م', price: 800, status: 'قيد الانتظار', notes: 'فحص دوري' },
  { id: 8, name: 'عمر خالد', phone: '01223344556', email: 'omar@email.com', service: 'استشارة قلبية', date: '2026-06-27', time: '04:00 م', price: 500, status: 'مؤكد', notes: '' },
];

export const initialChats = [
  { id: 1, name: 'محمد خالد توفيق ', lastMessage: 'شكراً جزيلاً على المساعدة', time: '10:30', unread: 0, avatar: 'أ', online: true },
  { id: 2, name: 'سارة علي', lastMessage: 'هل يمكنني تغيير موعد الحجز؟', time: '09:15', unread: 2, avatar: 'س', online: true },
  { id: 3, name: 'محمد حسن', lastMessage: 'أشعر بألم في الصدر', time: '08:45', unread: 1, avatar: 'م', online: false },
  { id: 4, name: 'فاطمة محمد خالد توفيق', lastMessage: 'متى يكون موعد الفحص القادم؟', time: 'أمس', unread: 0, avatar: 'ف', online: true },
  { id: 5, name: 'خالد سامي', lastMessage: 'هل هناك أدوية يجب تجنبها؟', time: 'أمس', unread: 0, avatar: 'خ', online: false },
  { id: 6, name: 'نور الدين', lastMessage: 'تمام، شكراً دكتور', time: 'قبل يومين', unread: 0, avatar: 'ن', online: true },
  { id: 7, name: 'ليلى محمود', lastMessage: 'هل أحتاج صيام قبل الفحص؟', time: 'قبل 3 أيام', unread: 0, avatar: 'ل', online: false },
];

export const chatMessagesData = {
  1: [
    { id: 1, sender: 'user', text: 'مرحباً دكتور، هل يمكنني حجز موعد لفحص استشاري النساء والتوليد؟', time: '10:00' },
    { id: 2, sender: 'admin', text: 'بالتأكيد! يمكنك اختيار الخدمة المناسبة من القائمة.', time: '10:01' },
    { id: 3, sender: 'user', text: 'أود حجز فحص قلب شامل', time: '10:02' },
    { id: 4, sender: 'admin', text: 'ممتاز. هل يمكنك تزويدي بتاريخ ووقت مناسب؟', time: '10:03' },
    { id: 5, sender: 'user', text: 'يوم 20 يونيو الساعة 10 صباحاً', time: '10:05' },
    { id: 6, sender: 'admin', text: 'تم تسجيل حجزك. نراك قريباً!', time: '10:06' },
    { id: 7, sender: 'user', text: 'شكراً جزيلاً على المساعدة', time: '10:30' },
  ],
  2: [
    { id: 1, sender: 'user', text: 'السلام عليكم', time: '09:00' },
    { id: 2, sender: 'admin', text: 'وعليكم السلام، كيف يمكنني مساعدتك؟', time: '09:01' },
    { id: 3, sender: 'user', text: 'هل يمكنني تغيير موعد الحجز؟', time: '09:15' },
  ],
  3: [
    { id: 1, sender: 'user', text: 'دكتور أشعر بألم في الصدر منذ الصباح', time: '08:30' },
    { id: 2, sender: 'admin', text: 'هل الألم مستمر أم متقطع؟', time: '08:35' },
    { id: 3, sender: 'user', text: 'مستمر ويزداد عند المجهود', time: '08:40' },
    { id: 4, sender: 'admin', text: 'أنصحك بزيارة الطوارئ فوراً', time: '08:42' },
    { id: 5, sender: 'user', text: 'أشعر بألم في الصدر', time: '08:45' },
  ],
  4: [
    { id: 1, sender: 'user', text: 'متى يكون موعد الفحص القادم؟', time: 'أمس' },
  ],
  5: [
    { id: 1, sender: 'user', text: 'هل هناك أدوية يجب تجنبها قبل الفحص؟', time: 'أمس' },
  ],
  6: [
    { id: 1, sender: 'admin', text: 'تم تأكيد موعدك يوم 25 يونيو', time: 'قبل يومين' },
    { id: 2, sender: 'user', text: 'تمام، شكراً دكتور', time: 'قبل يومين' },
  ],
  7: [
    { id: 1, sender: 'user', text: 'هل أحتاج صيام قبل فحص استشاري النساء والتوليد؟', time: 'قبل 3 أيام' },
  ],
};
